export default "__VITE_ASSET__eamYJm9I__"